import React from 'react';
import PanettoneProductGroups from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/ProductGroups/List.js';

export default function () {
  return <PanettoneProductGroups />;
}
